import { render, staticRenderFns } from "./importModal.vue?vue&type=template&id=65b35d16&scoped=true&"
import script from "./importModal.vue?vue&type=script&lang=js&"
export * from "./importModal.vue?vue&type=script&lang=js&"
import style0 from "./importModal.vue?vue&type=style&index=0&id=65b35d16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b35d16",
  null
  
)

export default component.exports